module.exports = __webpack_public_path__ + "img/logo-vista-health.f053ef9f.png";